module.exports = __webpack_public_path__ + "media/images/how-it-works/arena/step-5-055425d85fb419c40f8a7c43f60e0fa1.png";